import * as React from 'react';
import { FaSitemap } from 'react-icons/fa';
import { renderLine } from 'app/area/shared/codetable/list-item/list-item-lines';
import { Tag } from 'app/components/tag';
import { isDisabled } from 'app/infrastructure/data/date';
import { CodetableItemContentProps } from 'app/area/import-mappings/list-items/types';
import { ImportMappingType } from 'app/area/import-mappings/types-store';
import { isImportCodeModified, removeAllEnters } from 'app/area/import-mappings/list-items/modify-import-code';
import { importMappingCodeId } from 'app/area/import-mappings/list-items/current-import-code-mapping';
import styles from './codetable-item-content.scss';

export const CodetableItemContent = ({
  codeItem, isHierarchyMode, hierarchyMetadata, isCodetableWithCategory, refetching, treeDepthLevel, modifiedItems, updating, translation,
  setCurrentCode, clearValidation
}: Partial<CodetableItemContentProps>) => {

  const contentClass = !isHierarchyMode ? styles.content : styles.hierarchyContent;

  const onClick = () => {
    if (updating) {
      return;
    }

    clearValidation();
    setCurrentCode({
      ...codeItem,
      importMapping: codeItem.importMapping.filter(mapping => !!mapping.externalValue)
    });
  };

  const isEdited = !!isImportCodeModified(codeItem.id, codeItem.codetableId, modifiedItems);

  const validImportMappings = codeItem?.importMapping
    .filter(t => !!t.externalValue && t.type !== ImportMappingType.Deleted) ?? [];

  return (
    <div
      onClick={onClick}
      className={styles.container}>
      {isHierarchyMode
        ? renderLine(hierarchyMetadata, treeDepthLevel)
        : null}
      <div className={contentClass}>
        <div className={styles.leftSide}>
          <div className={styles.leftSideColumn}>
            <button
              id={importMappingCodeId(codeItem.codetableId, codeItem.id)}
              className={styles.codeItemButton}
              type="button">
              <>
                <span>{codeItem.description}</span>
                {!!codeItem.childrenCount && isHierarchyMode &&
                  <span className={styles.childrenCount}>
                    <FaSitemap />&nbsp;{codeItem.childrenCount}
                  </span>}
              </>
              {isDisabled(new Date(codeItem?.disabled)) && <div className={styles.tagWrapper}>
                <Tag className={styles.disabledTag}>
                  {translation.disabled}
                </Tag>
              </div>}
              {validImportMappings.length > 0
                && <div className={`${styles.tagWrapper} ${!isHierarchyMode ? styles.flatList : ''}`}>
                  <Tag className={styles.tag}>
                    <div className={styles.values}>
                      {removeAllEnters(codeItem?.importMapping
                        .filter(t => !!t.externalValue && t.type !== ImportMappingType.Deleted)
                        .map(item => item.externalValue)?.join(' | '))}
                    </div>
                  </Tag>
                </div>}
              {(refetching || isEdited) && <div className={styles.loader} />}
            </button>
          </div>
          {isCodetableWithCategory
            && <div className={styles.rightSideColumn}>
              {codeItem.category?.description
                ? <div className={`${styles.defaultColumn} ${styles.category}`}>{codeItem.category.description}</div>
                : null}
            </div>}
        </div>
      </div>
    </div>
  );
};
